import api from '../utils/api';

class BusOrdersApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/bus-orders', {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  createBooking = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/v1/booking/create', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateBooking = (data, id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/v1/booking/edit-order-route/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  createBookingRealTime = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('trigger/lockseat', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getBooking = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/booking/search', {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getBookingDetail = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/booking/segment/${id}`, {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getFromDestination = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/booking/list/from');
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getToDestination = (fromId) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/booking/list/to/${fromId}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/bus-orders', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  copy = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/payment-methods/copy/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/payment-methods/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/bus-orders/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/payment-methods/status/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updatePaymentStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/bus-orders/payment/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateOrderStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/bus-orders/order/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/payment-methods/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getBookingStatistics = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/booking/bookedseat/statistics/route`, {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getPaymentMethodOperator = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/booking/payment-method/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  paymentWave = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/v1/booking/payment/wave', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  paymentOm = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/v1/booking/payment/om', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  editOrder = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/v1/booking/edit-order/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  sendSmsTicket = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/v1/booking/booking/sms-ticket`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  sendSmsTicketTest = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/v1/booking/booking/sms-ticket/test`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getPassenger = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/booking/passengers/${data}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  exportToExcel = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/booking/export-orders/excel`, {
          params: data,
          responseType: 'blob',
        });
        // Create a link element, use it to download the blob, and then remove it
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Réservations_${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const busOrdersApi = new BusOrdersApi();
export default busOrdersApi;
